import { useCallback, useState } from 'react';
import { useDebounce } from 'usehooks-ts';

export const useSearchTerm = (debounceTime = 500) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchTermChange = useCallback((e) => {
    setSearchTerm(e.target.value);
  }, []);

  const debouncedSearchTerm = useDebounce(searchTerm, debounceTime);

  return {
    searchTerm,
    debouncedSearchTerm,
    handleSearchTermChange,
  };
};
